import React, { useEffect, useState, lazy } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
import { CheckIcon, ChevronRightIcon, ShieldIcon, StarIcon, TruckIcon } from 'lucide-react';
import { MetaPixel, trackInitiateCheckout } from '../components/MetaPixel';
export const ProductDetail = () => {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const getCheckoutLink = () => {
    return 'https://get.myhealthbeam.com/Clearnail/secure_checkout-1756400194976332-1756406025480233-1756493523952959';
  };
  return <div className="flex flex-col min-h-screen bg-white" id="top" data-id="element-238">
      <MetaPixel data-id="element-239" />
      <Header data-id="element-240" />
      <main className="flex-grow" data-id="element-241">
        {/* Hero Section */}
        <div className="bg-[#F0FDFA] py-12" data-id="element-242">
          <div className="container mx-auto px-4" data-id="element-243">
            <div className="md:flex md:items-center md:space-x-8" data-id="element-244">
              <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-245">
                <Link to="/adv" className="text-[#0D9488] text-sm hover:underline mb-4 inline-block" data-id="element-246">
                  &larr; Terug naar Artikel
                </Link>
                <h1 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-247">
                  Word Wakker met Gezondere, Heldere Nagels
                </h1>
                <h2 className="text-xl md:text-2xl text-[#0D9488] font-medium mb-4" data-id="element-248">
                  Doodt nagelschimmel bij de bron terwijl je slaapt
                </h2>
                <div className="flex items-center mb-4" data-id="element-249">
                  <div className="flex" data-id="element-250">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-251" />)}
                  </div>
                  <span className="ml-2 text-sm text-gray-600" data-id="element-252">
                    4.9 (3.278 beoordelingen)
                  </span>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-253">
                  ClearNail's gepatenteerde transdermale pleisters werken 's
                  nachts om krachtige antischimmelverbindingen rechtstreeks naar
                  de infectieplek te brengen. Onze unieke formule dringt de
                  nagel binnen om schimmel bij de bron te elimineren, zodat je
                  elke dag een stap dichter bij gezondere, heldere nagels komt.
                </p>
                <div className="hidden md:block" data-id="element-254">
                  <a href={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors" onClick={trackInitiateCheckout} data-id="element-255">
                    Kies Je Pakket
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-256" />
                  </a>
                </div>
              </div>
              <div className="md:w-1/2" data-id="element-257">
                <div className="bg-white rounded-lg overflow-hidden shadow-md" data-id="element-258">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bMDhyJEehiSsDMZZAdCFds/ezgif.com-video-to-webp-converter_4.webp" alt="Teennagel met schimmelinfectie die ClearNail behandelt" className="w-full h-auto object-cover" loading="eager" width="600" height="400" fetchpriority="high" data-id="element-259" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="container mx-auto px-4 py-12" data-id="element-260">
          <div className="mb-8 text-center" data-id="element-261">
            <h3 className="text-lg font-semibold text-[#0D9488] mb-2" data-id="element-262">
              Waarom ClearNail Werkt
            </h3>
            <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-263">
              Onze gepatenteerde transdermale technologie levert krachtige
              antischimmelverbindingen precies waar ze het meest nodig zijn.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-264">
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-265">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-266">
                <span className="text-[#0D9488] font-bold" data-id="element-267">1</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-268">Dringt de Nagel Binnen</h4>
              <p className="text-gray-600 text-sm" data-id="element-269">
                Micronaaldtechnologie creëert kanalen voor actieve ingrediënten
                om de infectiebron te bereiken
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-270">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-271">
                <span className="text-[#0D9488] font-bold" data-id="element-272">2</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-273">Elimineert Schimmel</h4>
              <p className="text-gray-600 text-sm" data-id="element-274">
                Krachtige botanische antischimmelmiddelen vallen de
                schimmelinfectie aan en vernietigen deze bij de bron
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-275">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-276">
                <span className="text-[#0D9488] font-bold" data-id="element-277">3</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-278">Herstelt Gezonde Nagels</h4>
              <p className="text-gray-600 text-sm" data-id="element-279">
                Voedende verbindingen bevorderen de groei van nieuw, gezond
                nagelweefsel
              </p>
            </div>
          </div>
          {/* Added How to Use section with image */}
          <div className="my-12" data-id="element-280">
            <h3 className="text-xl font-bold text-center mb-6" data-id="element-281">
              Hoe ClearNail te Gebruiken
            </h3>
            <div className="md:flex md:items-center md:space-x-8" data-id="element-282">
              <div className="md:w-1/2 mb-6 md:mb-0" data-id="element-283">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxpRpL5y2jQF8DFPyW9zPR/Google_AI_Studio_2025-08-28T15_31_37.543Z.png" alt="Close-up van handen die een transparante ClearNail pleister op een teen aanbrengen" className="w-full rounded-lg shadow-md" loading="lazy" width="600" height="400" data-id="element-284" />
              </div>
              <div className="md:w-1/2" data-id="element-285">
                <ol className="space-y-4" data-id="element-286">
                  <li className="flex" data-id="element-287">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-288">
                      1
                    </div>
                    <div data-id="element-289">
                      <h4 className="font-bold" data-id="element-290">
                        Reinig en droog je aangetaste nagel
                      </h4>
                      <p className="text-gray-600" data-id="element-291">
                        Zorg ervoor dat de nagel volledig droog is voor het
                        aanbrengen.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-292">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-293">
                      2
                    </div>
                    <div data-id="element-294">
                      <h4 className="font-bold" data-id="element-295">
                        Haal de pleister uit de verpakking
                      </h4>
                      <p className="text-gray-600" data-id="element-296">
                        Trek de beschermfolie terug om de plakzijde bloot te
                        leggen.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-297">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-298">
                      3
                    </div>
                    <div data-id="element-299">
                      <h4 className="font-bold" data-id="element-300">
                        Breng de pleister direct op de aangetaste nagel aan
                      </h4>
                      <p className="text-gray-600" data-id="element-301">
                        Druk stevig aan om volledig contact met het
                        nageloppervlak te garanderen.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-302">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-303">
                      4
                    </div>
                    <div data-id="element-304">
                      <h4 className="font-bold" data-id="element-305">
                        Laat 's nachts zitten (6-8 uur)
                      </h4>
                      <p className="text-gray-600" data-id="element-306">
                        Verwijder 's ochtends en gooi weg. Gebruik elke nacht
                        een nieuwe pleister.
                      </p>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="bg-gray-50 py-12" id="pricing" data-id="element-307">
          <div className="container mx-auto px-4" data-id="element-308">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-309">
              Kies Je Pakket
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-310">
              {/* Starter Bundle */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-311">
                <div className="p-6" data-id="element-312">
                  <h3 className="text-xl font-bold mb-2" data-id="element-313">Starter</h3>
                  <p className="text-gray-600 mb-4" data-id="element-314">
                    Voor lichte tot matige gevallen
                  </p>
                  <div className="mb-4" data-id="element-315">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-316">
                      24,90 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-317">
                    <strong data-id="element-318">1 Doos</strong> (14 pleisters)
                    <br data-id="element-319" />
                    2-weken behandelingskuur
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-320">
                    {['Behandelt enkele nagelinfecties', 'Ideaal voor beginnende schimmel', 'Zichtbare verbetering in 2 weken'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-321">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-322" />
                        <span className="text-sm" data-id="element-323">{feature}</span>
                      </li>)}
                  </ul>
                  <a href={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackInitiateCheckout} data-id="element-324">
                    Kies Starter Pakket
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-325" />
                  </a>
                </div>
              </div>
              {/* Standard Bundle */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-teal-500 transform md:scale-105" data-id="element-326">
                <div className="bg-teal-500 py-2 text-center" data-id="element-327">
                  <span className="text-white text-sm font-medium" data-id="element-328">
                    MEEST POPULAIR
                  </span>
                </div>
                <div className="p-6" data-id="element-329">
                  <h3 className="text-xl font-bold mb-2" data-id="element-330">Standaard</h3>
                  <p className="text-gray-600 mb-4" data-id="element-331">
                    Aanbevolen volledige kuur
                  </p>
                  <div className="mb-4" data-id="element-332">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-333">
                      39,90 €
                    </span>
                    <span className="ml-2 text-gray-500 line-through" data-id="element-334">
                      49,80 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-335">
                    <strong data-id="element-336">2 Dozen</strong> (28 pleisters)
                    <br data-id="element-337" />
                    Complete 4-weken behandeling
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-338">
                    {['Behandelt meerdere nagelinfecties', 'Volledige eliminatie van schimmel', 'Voorkomt terugkeer van schimmel', 'Bespaar 20% vergeleken met enkele doos'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-339">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-340" />
                        <span className="text-sm" data-id="element-341">{feature}</span>
                      </li>)}
                  </ul>
                  <a href={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackInitiateCheckout} data-id="element-342">
                    Kies Standaard Pakket
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-343" />
                  </a>
                </div>
              </div>
              {/* Complete Bundle */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-344">
                <div className="p-6" data-id="element-345">
                  <h3 className="text-xl font-bold mb-2" data-id="element-346">Compleet</h3>
                  <p className="text-gray-600 mb-4" data-id="element-347">
                    Beste waarde voor hardnekkige gevallen
                  </p>
                  <div className="mb-4" data-id="element-348">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-349">
                      49,90 €
                    </span>
                    <span className="ml-2 text-gray-500 line-through" data-id="element-350">
                      74,70 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-351">
                    <strong data-id="element-352">3 Dozen</strong> (42 pleisters)
                    <br data-id="element-353" />
                    Uitgebreide 6-weken behandeling
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-354">
                    {['Voor ernstige of hardnekkige infecties', 'Volledig nagelherstel', 'Verlengde beschermingsperiode', 'Bespaar 33% vergeleken met losse dozen'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-355">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-356" />
                        <span className="text-sm" data-id="element-357">{feature}</span>
                      </li>)}
                  </ul>
                  <a href={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackInitiateCheckout} data-id="element-358">
                    Kies Compleet Pakket
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-359" />
                  </a>
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-3 text-sm text-gray-600 max-w-md mx-auto mt-8 text-center" data-id="element-360">
              <div className="flex items-center justify-center" data-id="element-361">
                <TruckIcon size={16} className="mr-2" data-id="element-362" />
                <span data-id="element-363">Gratis verzending op alle bestellingen</span>
              </div>
              <div className="flex items-center justify-center" data-id="element-364">
                <ShieldIcon size={16} className="mr-2" data-id="element-365" />
                <span data-id="element-366">30 dagen tevredenheidsgarantie</span>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="container mx-auto px-4 py-12" data-id="element-367">
          <h2 className="text-2xl font-bold text-center mb-8" data-id="element-368">
            Wat Onze Klanten Zeggen
          </h2>
          {/* Added image of woman enjoying coffee */}
          <div className="mb-8" data-id="element-369">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tTgYz4xA4XFYhLR8ed9gKM/Google_AI_Studio_2025-08-28T15_32_02.603Z.png" alt="Tevreden klant die geniet van koffie in een café met een zelfverzekerde glimlach na het gebruik van ClearNail" className="w-full h-64 object-cover rounded-lg shadow-md mb-6" loading="lazy" width="800" height="400" data-id="element-370" />
            <p className="text-center text-gray-700 italic max-w-2xl mx-auto" data-id="element-371">
              "Nu kan ik genieten van mijn favoriete activiteiten zonder me
              zorgen te maken over het verbergen van mijn voeten. ClearNail
              heeft me mijn zelfvertrouwen teruggegeven!"
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-372">
            {[{
            name: 'Michael T.',
            review: 'Na talloze behandelingen te hebben geprobeerd gedurende 15 jaar, gaf ClearNail me eindelijk resultaten. Mijn nagels zijn voor het eerst in meer dan tien jaar weer helder!'
          }, {
            name: 'Sarah K.',
            review: 'Ik was jarenlang te beschaamd om sandalen te dragen. Na 4 weken met ClearNail laat ik mijn voeten weer zien. De transformatie is ongelooflijk.'
          }, {
            name: 'David R.',
            review: 'Als diabeticus maakte ik me zorgen over mijn nagelschimmel. Mijn arts raadde ClearNail aan, en het werkte zonder bijwerkingen. Sterk aanbevolen!'
          }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-373">
                <div className="flex items-center mb-3" data-id="element-374">
                  <div className="flex" data-id="element-375">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-376" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-377">
                    Geverifieerde Aankoop
                  </span>
                </div>
                <p className="italic mb-4" data-id="element-378">"{testimonial.review}"</p>
                <p className="text-sm font-medium" data-id="element-379">- {testimonial.name}</p>
              </div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-380" />
      {/* Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 transition-transform duration-300 ${isSticky ? 'translate-y-0' : 'translate-y-full'} md:hidden`} data-id="element-381">
        <div className="container mx-auto" data-id="element-382">
          <a href={getCheckoutLink()} className="flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackInitiateCheckout} data-id="element-383">
            Kies Je Pakket
            <ChevronRightIcon size={18} className="ml-1" data-id="element-384" />
          </a>
        </div>
      </div>
    </div>;
};